import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../unsettledBets';
var getUnsettledBets = function () {
    var _a;
    return (_a = {
            type: ActionTypes.FETCH_UNSETTLED_BETS
        },
        _a[CALL_API] = {
            endpoint: "/api/gambler/reporting/briefcase",
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_UNSETTLED_BETS,
                ActionTypes.FAILURE_FETCH_UNSETTLED_BETS
            ],
            credentials: true
        },
        _a);
};
var getUnsettledBetsDetails = function (languageId) {
    var _a;
    return (_a = {
            type: ActionTypes.FETCH_UNSETTLED_BETS_DETAILS
        },
        _a[CALL_API] = {
            endpoint: "/api/gambler/reporting/stakes/active?languageId=".concat(languageId),
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_UNSETTLED_BETS_DETAILS,
                ActionTypes.FAILURE_FETCH_UNSETTLED_BETS_DETAILS
            ],
            credentials: true
        },
        _a);
};
export var getData = function (languageId) {
    return function (dispatch) {
        dispatch(getUnsettledBets(languageId));
        return dispatch(getUnsettledBetsDetails(languageId));
    };
};



// WEBPACK FOOTER //
// ./src/actions/unsettled-bets/creators/unsettledBets.js